import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PdaCommonsModule } from './commons/pda-commons.module';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { HomeComponent } from './views/home/home.component';
import { ClassesComponent } from './views/classes/classes.component';
import { ScenesModule } from './scenes/scenes.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AboutComponent } from './views/about/about.component';
import { StaffComponent } from './views/staff/staff.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthTokenInterceptor } from './commons/interceptors/auth-token.interceptor';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ClassesComponent,
    AboutComponent,
    StaffComponent
  ],
  imports: [
    AppRoutingModule,
    PdaCommonsModule,
    NoopAnimationsModule,
    ScenesModule,
    NgbModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthTokenInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
